import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { TopGunHero } from '@/components/landing/topgun/topgun-hero'

import {
    TopGunProofSection,
    TopGunIssuesSection,
    TopGunServicesSection,
    TopGunProjectsSection,
    TopGunHowItWorksSection,
    TopGunGuaranteeSection,
    TopGunTeamSection,
    TopGunAreasSection,
    TopGunFaqSection,
    TopGunContactSection
} from '@/components/landing/topgun/topgun-sections'

const Home: FC = (): ReactNode => {
    return (
        <Layout heroTheme='dark'>
            <Seo description="We lift what sinks. Sunken driveways, sidewalks, patios and steps raised back into place. Serving homeowners across Kansas and Missouri." />

            <TopGunHero />
            <TopGunProofSection />
            <TopGunIssuesSection />
            <TopGunServicesSection />
            <TopGunProjectsSection />
            <TopGunHowItWorksSection />
            <TopGunGuaranteeSection />
            <TopGunTeamSection />
            <TopGunAreasSection />
            <TopGunFaqSection />
            <TopGunContactSection />
        </Layout>
    )
}

export default Home
